import { validate } from 'email-validator-internal'

export const validateEmail = email => {
  return validate(email)
}
